<template>
  <div class="app-container" v-show="isLogin">
    <!-- 中转仓记录 -->
    <div style="text-align: left">
      <div class="filter-container" style="margin-bottom: 10px">
        &nbsp;&nbsp;&nbsp;&nbsp;成交时间：
        <el-date-picker
          v-model="zzc_startDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="起始时间"
          :picker-options="zzc_pickerOptionsStart"
        ></el-date-picker>
        <span class="el-range-separator">至</span>
        <el-date-picker
          v-model="zzc_endDate"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="结束时间"
          :picker-options="zzc_pickerOptionsEnd"
        ></el-date-picker>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;订单号：<el-input
          v-model="listQuery.order"
          style="width: 13vw"
          class="filter-item"
          @keyup.enter.native="handleFilter"
          clearable
        />&nbsp;&nbsp;&nbsp;&nbsp;
        <el-button
          type="primary"
          style="
            font-size: 12px;
            background-color: #0850fc;
            color: white;
            height: 34px;
            border-radius: 0.5em;
            padding: 10px 12px;
          "
          @click="handleFilter"
          >查询</el-button
        >
        <el-table
          v-loading="listLoading"
          :data="zzcList"
          highlight-current-row
          style="color: rgb(70, 70, 70); margin-top: 10px"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '3px 0' }"
          :header-cell-style="{
            background: 'rgb(247 248 252) !important',
            color: '#ededed  !important',
            padding: '7px 0',
            color: 'rgb(140, 140, 140)',
          }"
        >
          <!-- 操作时间	中转仓订单号	订单编号	仓库	重量	预付款	实际付款金额	操作说明  -->
          <el-table-column label="操作时间" prop="ID" align="left" min-width="1.5">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.created_at">{{ row.created_at }}</span>
            </template>
          </el-table-column>
          <el-table-column label="中转仓订单号" min-width="2" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.extra_param1">{{
                row.extra_param1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单编号" min-width="2" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.order_no">{{ row.order_no }}</span>
            </template>
          </el-table-column>
          <el-table-column label="仓库" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.cang">{{ row.cang }}</span>
            </template>
          </el-table-column>
          <el-table-column label="重量" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.weight">{{ row.weight }}</span>
            </template>
          </el-table-column>
          <el-table-column label="预付款" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.money">{{ row.money }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际付款金额" min-width="1.3" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.real_price">{{ row.real_price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作说明" min-width="4" align="left">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.remarks">{{ row.remarks }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="zzcTotal > 0"
          :total="zzcTotal"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.perPage"
          style="padding-top: 12px; padding-bottom: 0px; text-align: center"
          @pagination="getList"
        />
        <!-- layout="total, prev, pager, next" -->
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves"; // waves directive
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import moment from "moment";

export default {
  name: "zzcOrders",
  components: {
    Pagination,
    "el-date-picker": DatePicker,
  },
  directives: { waves },
  data() {
    return {
      zzcList: [],

      zzcTotal: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        perPage: 20,
        date_one: this.zzc_startDate,
        date_two: this.zzc_endDate,
        order: "",
      },

      zzc_startDate: "",
      zzc_endDate:  new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(), 23, 59, 59),

      zzc_pickerOptionsStart: {
        disabledDate: (time) => {
          let zzc_endDateVal = this.zzc_endDate;
          if (zzc_endDateVal) {
            return time.getTime() > new Date(zzc_endDateVal).getTime(); //选则的时间
          }
        },
      },
      zzc_pickerOptionsEnd: {
        disabledDate: (time) => {
          let zzc_beginDateVal = this.zzc_startDate;
          if (zzc_beginDateVal) {
            return time.getTime() < new Date(zzc_beginDateVal).getTime();
          }
        },
      },
    };
  },
  created() {
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到简介页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/zzc/jianjie" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList();
  },
  methods: {
    async getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/zzc/jianjie" });
          });
        return;
      }

      this.zzcList = [];
      if (this.zzc_startDate == "") {
        const nowDay = new Date();
        let mon = nowDay.getMonth() + 1;
        if (mon < 10) {
          mon = "0" + mon;
        }
        //默认30天
        let nm = nowDay.getMonth();
        if (nm < 10) {
          nm = "0" + nm;
        }
        this.listQuery.date_one =
          nowDay.getFullYear() + "-" + nm + "-" + nowDay.getDate() + " 00:00:00";
        this.zzc_startDate = this.listQuery.date_one;
      } else {
        this.listQuery.date_one = moment(this.zzc_startDate).format("YYYY-MM-DD HH:mm:ss");
      }
      if (this.zzc_endDate == "") {
        this.zzc_endDate = new Date().toLocaleString();
        this.listQuery.date_two = new Date().toLocaleString();
      } else {
        this.listQuery.date_two = moment(this.zzc_endDate).format("YYYY-MM-DD HH:mm:ss");
      }

      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/zzcOrder";
      const token = Cookies.get("view_userToken");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == "200") {
            this.zzcList = resd.data.data;
            this.zzcTotal = resd.data.total;

            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
  },
};
</script>

<style>
@import "vue2-datepicker/index.css";

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/zzc/orders.vue